import isEmpty from "lodash-es/isEmpty"

import type {
    IAvailableCoachDto,
    IAvailableCoachModel,
    ICoachInfoDto,
    ICoachInfoModel,
    ICoachingSessionCoachDto,
    ICoachingSessionCoachModel
} from "@/3514/types"

function coachInfoAdapter(dto: ICoachInfoDto): ICoachInfoModel {
    return isEmpty(dto)
        ? null
        : {
              bio: dto.bio_data,
              certification: dto.certification,
              country: dto.country,
              email: dto.email,
              firstName: dto.first_name,
              id: dto.id,
              langCode: dto.language_code,
              lastName: dto.last_name,
              location: dto.location,
              photo: dto.photo,
              userId: dto.user_id
          }
}

function coachingSessionCoachAdapter(dto: ICoachingSessionCoachDto): ICoachingSessionCoachModel {
    return isEmpty(dto)
        ? null
        : {
              certification: dto.certification,
              cohortId: isEmpty(dto.cohorts) ? null : dto.cohorts.id,
              cohortName: isEmpty(dto.cohorts) ? null : dto.cohorts.name,
              cohortSlug: isEmpty(dto.cohorts) ? null : dto.cohorts.slug,
              country: dto.country,
              firstName: dto.first_name,
              id: dto.id,
              lastName: dto.last_name,
              location: dto.location,
              photo: dto.photo
          }
}

function availableCoachAdapter(dto: IAvailableCoachDto): IAvailableCoachModel {
    return isEmpty(dto)
        ? null
        : {
              bio: dto.bio_data,
              certification: dto.certification,
              country: dto.country,
              email: dto.email,
              firstName: dto.first_name,
              id: dto.id,
              lastName: dto.last_name,
              location: dto.location,
              photo: dto.photo,
              userId: dto.user_id
          }
}

export { coachInfoAdapter, coachingSessionCoachAdapter, availableCoachAdapter }
